import React from 'react';

const SetupContainer = ({children}) => {
    return (
        <div className=''>
            {children}
        </div>
    );
};

export default SetupContainer;